import React from "react";
import { DateTime } from "luxon";
import { amountFormatter } from "services";

interface AssetEventDetailsProps {
  currentUserLatestBid: any;
  isCurrentUserHighestBidder: boolean;
  latestBiddingAmount: number;
  incrementAmount: number;
  reservePrice: string | number;
  biddingIncrementAmount: string | number;
  status: "accepted" | "live" | "end";
  endTimeMillis: number;
}

export default function AssetEventDetails({
  currentUserLatestBid,
  isCurrentUserHighestBidder,
  latestBiddingAmount,
  incrementAmount,
  reservePrice,
  biddingIncrementAmount,
  status,
  endTimeMillis,
}: AssetEventDetailsProps) {
  return (
    <div className="text-xs px-[10px] font-sans text-brand-textBlack">
      <div className="pt-4 pb-5 flex justify-between items-center">
        <dt className="text-sm font-semibold text-brand-textBlack">
          Event Details
        </dt>
      </div>
      <dl className={`divide-y "divide-gray-300"`}>
        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">Your Last Bid</dt>
          <dd className="">
            {currentUserLatestBid ? (
              <span
                className={`font-bold ${
                  isCurrentUserHighestBidder ? "text-green-500" : "text-red-500"
                }`}
              >
                ₹ {amountFormatter(currentUserLatestBid.bidding_amount)}
              </span>
            ) : (
              "NA"
            )}
          </dd>
        </div>

        <div className="py-3 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">
            Next Possible Bid
          </dt>
          <dd className="text-xs">
            ₹ {amountFormatter(latestBiddingAmount + incrementAmount)} or above
          </dd>
        </div>

        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">Reserve Price</dt>
          <dd className="text-xs">₹ {amountFormatter(reservePrice)}</dd>
        </div>

        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">
            Bid Increment Amount
          </dt>
          <dd className="text-xs">
            ₹ {amountFormatter(biddingIncrementAmount)}
          </dd>
        </div>

        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">
            {status === "end" ? "Ended at" : "Ends at"}
          </dt>
          <dd className="">
            {DateTime.fromMillis(endTimeMillis)
              .setZone("Asia/Kolkata")
              .toFormat("hh:mm:ss a")}{" "}
            (IST)
          </dd>
        </div>

        <div className="py-4 grid grid-cols-2 gap-2">
          <dt className="text-xs text-brand-textLightGrey">
            Number of Extensions
          </dt>
          <dd className="">0</dd>
        </div>
      </dl>
    </div>
  );
}
